import React, { useMemo } from 'react';

import { useLocalSearchParams } from 'expo-router';

import { MenuNavigationTabs } from 'pages/menu/components/menu-navigation-tabs/menu-navigation-tabs';
import { MenuSection } from 'pages/menu/components/menu-section/menu-section';
import { useUnifiedMenuContext } from 'state/unified-menu';

import { MenuHeaderNavigation } from '../components/menu-header-navigation';

// NEW one menu
export const MenuSectionPage = () => {
  const { mainMenu } = useUnifiedMenuContext();
  const { id } = useLocalSearchParams<{ id: string }>();

  const { title, options } = useMemo(() => {
    const section = mainMenu?.find(section => section.id === id);
    return { title: section?.name || '', options: section?.children || [] };
  }, [id, mainMenu]);

  return (
    <>
      {/* key is used to force re-render and display Section name after reloading page, 
          there is a memo messing up prop comparison */}
      <MenuHeaderNavigation title={title} key={title} />
      <MenuNavigationTabs mainMenu={mainMenu} />
      <MenuSection data={options} objectFitContain={true} />
    </>
  );
};
